import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getCollectionBackLink } from "../../config/itemCollectionLinks";

const BackToCollection = ({ to, label }) => {
  const { pathname } = useLocation();
  const backLink = getCollectionBackLink(pathname, { to, label });

  if (!backLink) {
    return null;
  }

  return (
    <nav className="item-back-nav" aria-label="Collection navigation">
      <Link className="item-back-link" to={backLink.path}>
        <span aria-hidden="true">←</span>
        Back to {backLink.label}
      </Link>
    </nav>
  );
};

export default BackToCollection;
